var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClosecomponent = function SvgClosecomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 7.63a.728.728 0 0 1-.482-.203l-5.343-5.41c-.263-.244-.219-.61.044-.854s.657-.204.92.04l5.343 5.37a.562.562 0 0 1-.044.854c-.132.122-.263.203-.438.203Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.657 13a.586.586 0 0 1-.438-.163.597.597 0 0 1-.044-.854l5.343-5.37a.716.716 0 0 1 .92-.04c.263.244.263.61.044.854l-5.343 5.37a.728.728 0 0 1-.482.203Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 7.63a.585.585 0 0 1-.438-.162.597.597 0 0 1-.044-.854l5.343-5.41a.716.716 0 0 1 .92-.041c.306.244.306.61.044.854l-5.343 5.41A.728.728 0 0 1 7 7.63Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.343 13a.728.728 0 0 1-.482-.203l-5.343-5.37a.561.561 0 0 1 .044-.854.669.669 0 0 1 .92.04l5.343 5.37a.562.562 0 0 1-.044.854.586.586 0 0 1-.438.163Z",
    fill: "current"
  })));
};
export default SvgClosecomponent;